import { ComponentType } from '@angular/cdk/portal';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of } from 'rxjs';
import { DialogComponent } from '../_utils/dialog-component';
import { ErrorDialogConfig } from '../_config/error-dialog-config';
import { MessageDialogComponent } from '../_widgets/message-dialog/message-dialog.component';
import { ErrorToastComponent } from '../_widgets/error-toast/error-toast.component';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog, private snackbar: MatSnackBar) {}

  open<
    T extends DialogComponent<T, D, R>,
    D = T['data'],
    R = Parameters<T['dialogRef']['close']>[0]
  >(
    component: ComponentType<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    let ref = this.dialog.open<T, D, R>(component, config);
    return ref;
  }

  onSuccess(message = 'Operazione completata', action = 'Chiudi') {
    return this.snackbar.open(message, action, {
      duration: 2000,
    });
  }

  onError(error: any, action = 'Chiudi') {
    let message = 'Errore generico';
    if (typeof error === 'string') {
      message = error;
    } else if (error?.message && typeof error.message === 'string') {
      message = error.message;
    }
    return this.snackbar.openFromComponent(ErrorToastComponent, {
      //panelClass: 'error-snackbar',
      horizontalPosition: 'center',
      verticalPosition: 'top',
      data: { message, action },
    });
  }

  manageError(
    err: string | HttpErrorResponse,
    message?: string,
    title?: string
  ) {
    console.error(err);
    if (!(err instanceof HttpErrorResponse)) {
      return this.dialog
        .open(
          MessageDialogComponent,
          new ErrorDialogConfig(message || err, title)
        )
        .afterClosed();
    } else {
      return of(null);
    }
  }
}

export type DialogReturnData<
  C extends DialogComponent<T, D, R>,
  T = C,
  D = C['data'],
  R = Parameters<C['dialogRef']['close']>[0]
> = NonNullable<R>;
